import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getBooking,
  getIdBooking,
  createBooking,
  updateBooking,
  deleteBooking,
  updateBookingSetStatus,
  updateBookingConfirm,
  updateBookingCancel,
  getVehicle,
  createVehicle,
  updateVehicle,
  deleteBookingVehicles,
  createParty,
  updateParty,
  deleteParty,
  getparty,
  updateBookingAmmend,
  uploadBookingVehicle,
  getGenerateExcelBlob
} from "./bookingAPI";

const initialState = {
  data: [],
  dataParty: [],
  dataPartyAll: [],
  dataPartyAllFilter: [],
  dataId: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
  pageNoParty: 1,
  pageSizeParty: 10,
  totalRecordParty: 0,
};

export const fetchBooking = createAsyncThunk(
  "Booking/fetchBooking",
  async (payload) => {
    const response = await getBooking(payload);
    return response;
  }
);

export const addBooking = createAsyncThunk(
  "Booking/addBooking",
  async (payload) => {
    const response = await createBooking(payload);
    return response;
  }
);

export const editBooking = createAsyncThunk(
  "Booking/editBooking",
  async (payload) => {
    const response = await updateBooking(payload);
    return response;
  }
);

export const editBookingConfirm = createAsyncThunk(
  "Booking/editBookingConfirm",
  async (payload) => {
    const response = await updateBookingConfirm(payload);
    return response;
  }
);

export const editBookingCancel = createAsyncThunk(
  "Booking/editBookingCancel",
  async (payload) => {
    const response = await updateBookingCancel(payload);
    return response;
  }
);
export const editBookingAmmend = createAsyncThunk(
  "Booking/editBookingAmmend",
  async (payload) => {
    const response = await updateBookingAmmend(payload);
    return response;
  }
);

export const fetchIdBooking = createAsyncThunk(
  "Booking/fetchIdBooking",
  async (id) => {
    const response = await getIdBooking(id);
    return response;
  }
);

export const removeBooking = createAsyncThunk(
  "Booking/removeBooking",
  async (payload) => {
    const response = await deleteBooking(payload);
    return response;
  }
);

// vihicle
export const fetchBookingVehicle = createAsyncThunk(
  "Booking/fetchBookingVehicle",
  async (payload) => {
    const response = await getVehicle(payload);
    return response;
  }
);

export const addBookingVehicle = createAsyncThunk(
  "Booking/addBookingVehicle",
  async (payload) => {
    const response = await createVehicle(payload);
    return response;
  }
);
export const removeBookingVehicle = createAsyncThunk(
  "Booking/removeBookingVehicle",
  async (payload) => {
    const response = await deleteBookingVehicles(payload);
    return response;
  }
);

export const editBookingVehicle = createAsyncThunk(
  "Booking/editBookingVehicle",
  async (payload) => {
    const response = await updateVehicle(payload);
    return response;
  }
);

export const AddUploadFile = createAsyncThunk(
  "Booking/AddUploadFile",
  async ({ id, file }) => {
    const response = await uploadBookingVehicle(id, file);
    return response;
  }
);

// party
export const fetchBookingParty = createAsyncThunk(
  "Booking/fetchBookingParty",
  async (payload) => {
    const response = await getparty(payload);
    return response;
  }
);
export const fetchBookingPartyAll = createAsyncThunk(
  "Booking/fetchBookingPartyAll",
  async (payload) => {
    const response = await getparty(payload);
    return response;
  }
);

export const fetchBookingPartyAllFilter = createAsyncThunk(
  "Booking/fetchBookingPartyAllFilter",
  async (payload) => {
    const response = await getparty(payload);
    return response;
  }
);

export const addBookingParty = createAsyncThunk(
  "Booking/addBookingParty",
  async (payload) => {
    const response = await createParty(payload);
    return response;
  }
);

export const editBookingParty = createAsyncThunk(
  "Booking/editBookingParty",
  async (payload) => {
    const response = await updateParty(payload);
    return response;
  }
);

export const removeBookingParty = createAsyncThunk(
  "Booking/removeBookingParty",
  async (payload) => {
    const response = await deleteParty(payload);
    return response;
  }
);

// Generate Excel
export const fetchGenerateExcel = createAsyncThunk(
  "Booking/fetchGenerateExcel",
  async (payload) => {
    const response = await getGenerateExcelBlob(payload);
    return response;
  }
);

export const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBooking.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBooking.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchIdBooking.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdBooking.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })

      .addCase(addBooking.pending, (state) => {
        state.loading = true;
      })
      .addCase(addBooking.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(editBooking.pending, (state) => {
        state.loading = true;
      })
      .addCase(editBooking.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editBookingConfirm.pending, (state) => {
        state.loading = true;
      })
      .addCase(editBookingConfirm.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editBookingCancel.pending, (state) => {
        state.loading = true;
      })
      .addCase(editBookingCancel.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editBookingAmmend.pending, (state) => {
        state.loading = true;
      })
      .addCase(editBookingAmmend.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeBooking.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeBooking.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchBookingVehicle.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBookingVehicle.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(addBookingVehicle.pending, (state) => {
        state.loading = true;
      })
      .addCase(addBookingVehicle.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editBookingVehicle.pending, (state) => {
        state.loading = true;
      })
      .addCase(editBookingVehicle.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(AddUploadFile.pending, (state) => {
        state.loading = true;
      })
      .addCase(AddUploadFile.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeBookingVehicle.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeBookingVehicle.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      // party
      .addCase(fetchBookingParty.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBookingParty.fulfilled, (state, action) => {
        state.loading = false;
        state.dataParty = action.payload.data.data;
        state.pageNoParty = action.payload.data.pageNo;
        state.pageSizeParty = action.payload.data.pageSize;
        state.totalRecordParty = action.payload.data.totalRecord;
      })
      .addCase(fetchBookingPartyAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBookingPartyAll.fulfilled, (state, action) => {
        state.loading = false;
        state.dataPartyAll = action.payload.data.data;
      })
      .addCase(fetchBookingPartyAllFilter.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBookingPartyAllFilter.fulfilled, (state, action) => {
        state.loading = false;
        state.dataPartyAllFilter = action.payload.data.data;
      })
      .addCase(addBookingParty.pending, (state) => {
        state.loading = true;
      })
      .addCase(addBookingParty.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editBookingParty.pending, (state) => {
        state.loading = true;
      })
      .addCase(editBookingParty.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeBookingParty.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeBookingParty.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected } = bookingSlice.actions;

export const selectBooking = (state) => state.booking.data;
export const selectBookingVehicle = (state) => state.booking.data;
export const selectIdBooking = (state) => state.booking.dataId;
export const selectLoading = (state) => state.booking.loading;
export const selectError = (state) => state.booking.error;
export const selectPageNo = (state) => state.booking.pageNo;
export const selectPageSize = (state) => state.booking.pageSize;
export const selectTotalRecord = (state) => state.booking.totalRecord;
export const selectSelected = (state) => state.booking.selected;
export const selectResult = (state) => state.booking.result;
export const selectBookingParty = (state) => state.booking.dataParty;
export const selectBookingPartyAll = (state) => state.booking.dataPartyAll;
export const selectBookingPartyAllFilter = (state) => state.booking.dataPartyAllFilter;

export const selectPageNoParty = (state) => state.booking.pageNoParty;
export const selectPageSizeParty = (state) => state.booking.pageSizeParty;
export const selectTotalRecordParty = (state) => state.booking.totalRecordParty;

export default bookingSlice.reducer;
